/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponseDTOEmployerDTO,
  ApiResponseDTOListEmployerDTO,
  ApiResponseDTOVoid,
  EmployerCreateRequestDTO,
  PublicSearchEmployersParams,
  SearchEmployersParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getEmployer = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOEmployerDTO>(
      {url: `/frontend/v1/employers/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetEmployerInfiniteQueryKey = (id?: number,) => {
    return [
    'infinite', `/frontend/v1/employers/${id}`
    ] as const;
    }

export const getGetEmployerQueryKey = (id?: number,) => {
    return [
    `/frontend/v1/employers/${id}`
    ] as const;
    }

    
export const getGetEmployerInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getEmployer>>>, TError = unknown>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployer>>> = ({ signal }) => getEmployer(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetEmployerInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployer>>>
export type GetEmployerInfiniteQueryError = unknown


export function useGetEmployerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEmployer>>>, TError = unknown>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployer>>,
          TError,
          Awaited<ReturnType<typeof getEmployer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEmployer>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployer>>,
          TError,
          Awaited<ReturnType<typeof getEmployer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEmployer>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetEmployerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEmployer>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetEmployerInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getEmployer>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployerQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployer>>> = ({ signal }) => getEmployer(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployer>>>
export type GetEmployerQueryError = unknown


export function useGetEmployer<TData = Awaited<ReturnType<typeof getEmployer>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployer>>,
          TError,
          Awaited<ReturnType<typeof getEmployer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployer<TData = Awaited<ReturnType<typeof getEmployer>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployer>>,
          TError,
          Awaited<ReturnType<typeof getEmployer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployer<TData = Awaited<ReturnType<typeof getEmployer>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetEmployer<TData = Awaited<ReturnType<typeof getEmployer>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetEmployerQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateEmployer = (
    id: number,
    employerCreateRequestDTO: EmployerCreateRequestDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDTOEmployerDTO>(
      {url: `/frontend/v1/employers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: employerCreateRequestDTO
    },
      options);
    }
  


export const getUpdateEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployer>>, TError,{id: number;data: EmployerCreateRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmployer>>, TError,{id: number;data: EmployerCreateRequestDTO}, TContext> => {

const mutationKey = ['updateEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmployer>>, {id: number;data: EmployerCreateRequestDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEmployer(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmployer>>>
    export type UpdateEmployerMutationBody = EmployerCreateRequestDTO
    export type UpdateEmployerMutationError = unknown

    export const useUpdateEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmployer>>, TError,{id: number;data: EmployerCreateRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmployer>>,
        TError,
        {id: number;data: EmployerCreateRequestDTO},
        TContext
      > => {

      const mutationOptions = getUpdateEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteEmployer = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDTOVoid>(
      {url: `/frontend/v1/employers/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployer>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployer(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployer>>>
    
    export type DeleteEmployerMutationError = unknown

    export const useDeleteEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployer>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const enableEmployer = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDTOEmployerDTO>(
      {url: `/frontend/v1/employers/${id}/enable`, method: 'PUT'
    },
      options);
    }
  


export const getEnableEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableEmployer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof enableEmployer>>, TError,{id: number}, TContext> => {

const mutationKey = ['enableEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableEmployer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  enableEmployer(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EnableEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof enableEmployer>>>
    
    export type EnableEmployerMutationError = unknown

    export const useEnableEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableEmployer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableEmployer>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getEnableEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const disableEmployer = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ApiResponseDTOEmployerDTO>(
      {url: `/frontend/v1/employers/${id}/disable`, method: 'PUT'
    },
      options);
    }
  


export const getDisableEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableEmployer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disableEmployer>>, TError,{id: number}, TContext> => {

const mutationKey = ['disableEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableEmployer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  disableEmployer(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DisableEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof disableEmployer>>>
    
    export type DisableEmployerMutationError = unknown

    export const useDisableEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableEmployer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableEmployer>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDisableEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const searchEmployers = (
    params?: SearchEmployersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOListEmployerDTO>(
      {url: `/frontend/v1/employers`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchEmployersInfiniteQueryKey = (params?: SearchEmployersParams,) => {
    return [
    'infinite', `/frontend/v1/employers`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchEmployersQueryKey = (params?: SearchEmployersParams,) => {
    return [
    `/frontend/v1/employers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchEmployersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchEmployers>>>, TError = unknown>(params?: SearchEmployersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchEmployersInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchEmployers>>> = ({ signal }) => searchEmployers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchEmployersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchEmployers>>>
export type SearchEmployersInfiniteQueryError = unknown


export function useSearchEmployersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchEmployers>>>, TError = unknown>(
 params: undefined |  SearchEmployersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEmployers>>,
          TError,
          Awaited<ReturnType<typeof searchEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchEmployersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchEmployers>>>, TError = unknown>(
 params?: SearchEmployersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEmployers>>,
          TError,
          Awaited<ReturnType<typeof searchEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchEmployersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchEmployers>>>, TError = unknown>(
 params?: SearchEmployersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchEmployersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchEmployers>>>, TError = unknown>(
 params?: SearchEmployersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchEmployersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchEmployersQueryOptions = <TData = Awaited<ReturnType<typeof searchEmployers>>, TError = unknown>(params?: SearchEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchEmployersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchEmployers>>> = ({ signal }) => searchEmployers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof searchEmployers>>>
export type SearchEmployersQueryError = unknown


export function useSearchEmployers<TData = Awaited<ReturnType<typeof searchEmployers>>, TError = unknown>(
 params: undefined |  SearchEmployersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEmployers>>,
          TError,
          Awaited<ReturnType<typeof searchEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchEmployers<TData = Awaited<ReturnType<typeof searchEmployers>>, TError = unknown>(
 params?: SearchEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchEmployers>>,
          TError,
          Awaited<ReturnType<typeof searchEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchEmployers<TData = Awaited<ReturnType<typeof searchEmployers>>, TError = unknown>(
 params?: SearchEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchEmployers<TData = Awaited<ReturnType<typeof searchEmployers>>, TError = unknown>(
 params?: SearchEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchEmployersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createEmployer = (
    employerCreateRequestDTO: EmployerCreateRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOEmployerDTO>(
      {url: `/frontend/v1/employers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employerCreateRequestDTO, signal
    },
      options);
    }
  


export const getCreateEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: EmployerCreateRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: EmployerCreateRequestDTO}, TContext> => {

const mutationKey = ['createEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployer>>, {data: EmployerCreateRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  createEmployer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployer>>>
    export type CreateEmployerMutationBody = EmployerCreateRequestDTO
    export type CreateEmployerMutationError = unknown

    export const useCreateEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployer>>, TError,{data: EmployerCreateRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmployer>>,
        TError,
        {data: EmployerCreateRequestDTO},
        TContext
      > => {

      const mutationOptions = getCreateEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const publicSearchEmployers = (
    params?: PublicSearchEmployersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiResponseDTOListEmployerDTO>(
      {url: `/frontend/v1/employers/public-search`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPublicSearchEmployersInfiniteQueryKey = (params?: PublicSearchEmployersParams,) => {
    return [
    'infinite', `/frontend/v1/employers/public-search`, ...(params ? [params]: [])
    ] as const;
    }

export const getPublicSearchEmployersQueryKey = (params?: PublicSearchEmployersParams,) => {
    return [
    `/frontend/v1/employers/public-search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPublicSearchEmployersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof publicSearchEmployers>>>, TError = unknown>(params?: PublicSearchEmployersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicSearchEmployersInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicSearchEmployers>>> = ({ signal }) => publicSearchEmployers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PublicSearchEmployersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof publicSearchEmployers>>>
export type PublicSearchEmployersInfiniteQueryError = unknown


export function usePublicSearchEmployersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof publicSearchEmployers>>>, TError = unknown>(
 params: undefined |  PublicSearchEmployersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicSearchEmployers>>,
          TError,
          Awaited<ReturnType<typeof publicSearchEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePublicSearchEmployersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof publicSearchEmployers>>>, TError = unknown>(
 params?: PublicSearchEmployersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicSearchEmployers>>,
          TError,
          Awaited<ReturnType<typeof publicSearchEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePublicSearchEmployersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof publicSearchEmployers>>>, TError = unknown>(
 params?: PublicSearchEmployersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePublicSearchEmployersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof publicSearchEmployers>>>, TError = unknown>(
 params?: PublicSearchEmployersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPublicSearchEmployersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPublicSearchEmployersQueryOptions = <TData = Awaited<ReturnType<typeof publicSearchEmployers>>, TError = unknown>(params?: PublicSearchEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicSearchEmployersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicSearchEmployers>>> = ({ signal }) => publicSearchEmployers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type PublicSearchEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof publicSearchEmployers>>>
export type PublicSearchEmployersQueryError = unknown


export function usePublicSearchEmployers<TData = Awaited<ReturnType<typeof publicSearchEmployers>>, TError = unknown>(
 params: undefined |  PublicSearchEmployersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicSearchEmployers>>,
          TError,
          Awaited<ReturnType<typeof publicSearchEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePublicSearchEmployers<TData = Awaited<ReturnType<typeof publicSearchEmployers>>, TError = unknown>(
 params?: PublicSearchEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicSearchEmployers>>,
          TError,
          Awaited<ReturnType<typeof publicSearchEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function usePublicSearchEmployers<TData = Awaited<ReturnType<typeof publicSearchEmployers>>, TError = unknown>(
 params?: PublicSearchEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function usePublicSearchEmployers<TData = Awaited<ReturnType<typeof publicSearchEmployers>>, TError = unknown>(
 params?: PublicSearchEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicSearchEmployers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getPublicSearchEmployersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




